import { useState } from 'react';

import { ProfilePhoneNumberVerification } from '../profilePhoneNumberVerification/ProfilePhoneNumberVerification';
import { ProfilePinNumberVerification } from '../profilePinNumberVerification/ProfilePinNumberVerification';

export const ProfilePhone = ({ adId, isLoggedIn }: { adId: number; isLoggedIn: boolean }) => {
    const [displayLogin, setDisplayLogin] = useState(false);
    const [displayRequestForm, setDisplayRequestForm] = useState(false);
    const [displayPinVerification, setDisplayPinVerification] = useState(false);
    const [invalidPin, setInvalidPin] = useState(false);
    const [invalidNumber, setInvalidNumber] = useState(false);
    const [adOwnerPhoneNumber, setAdOwnerPhoneNumber] = useState('');
    const [userInputPhoneNumber, setUserInputPhoneNumber] = useState('');

    const request = (query) => fetch(`/verification/properties/${query}`, { credentials: 'include' }).then((response) => response.json());

    const handleSubmitNumber = (phoneNumber) =>
        request(`requestpincode.json?phoneNumber=${phoneNumber}&adId=${adId}`).then((json) => {
            if (json.result && json.result.result.sendPinStatus === 'OK') {
                setDisplayRequestForm(false);
                setDisplayPinVerification(true);
                setUserInputPhoneNumber(phoneNumber);
            } else if (json.result && json.result.result.sendPinStatus === 'INVALID_NUMBER') {
                setInvalidNumber(true);
            }
        });

    const handleSubmitPin = (pin) =>
        request(`validatepin.json?pin=${pin}&phoneNumber=${userInputPhoneNumber}&adId=${adId}`).then((json) => {
            if (json.result && json.result.validationStatus === 'OK') {
                setDisplayRequestForm(false);
                setDisplayPinVerification(false);
                setDisplayLogin(false);
            } else if (json.result && json.result.validationStatus === 'WRONG_PIN') {
                setDisplayRequestForm(true);
                setInvalidPin(true);
            }
            setDisplayPinVerification(false);
        });

    const handleShowPhone = (event) => {
        event.preventDefault();
        if (displayRequestForm || displayPinVerification) {
            return; // ignore clicks while in verification process
        }

        if (isLoggedIn) {
            return request(`phonenumbers.json?adId=${adId}`).then((json) => {
                if (json.result && json.result.result.verified === 'OK') {
                    const numbers = handleJsonNumbers(Object.values(json.result.result.phoneNumbers).shift());
                    setAdOwnerPhoneNumber(numbers?.mobile ?? numbers?.phone ?? '');
                } else if (json.result && json.result.result.verified === 'NEED_VERIFICATION') {
                    setDisplayRequestForm(true);
                }
            });
        } else {
            setDisplayLogin(true);
        }
    };

    return (
        <div className="text-14 mt-8" data-testid="phoneNumber">
            {adOwnerPhoneNumber ? (
                <a href={`tel:${adOwnerPhoneNumber}`} data-testid="phoneNumberLink">
                    {adOwnerPhoneNumber}
                </a>
            ) : (
                <button className="link" onClick={handleShowPhone}>
                    Vis mobilnummer
                </button>
            )}
            {displayRequestForm && (
                <ProfilePhoneNumberVerification
                    handleSubmitNumber={handleSubmitNumber}
                    invalidNumber={invalidNumber}
                    invalidPin={invalidPin}
                />
            )}
            {displayPinVerification && <ProfilePinNumberVerification handleSubmitPin={handleSubmitPin} />}
            {displayLogin && (
                <div className="mt-8" data-testid="loginInfo">
                    Du må være innlogget for å se nummeret.
                    <br />
                    <a data-testid="phoneLogin" href="/auth/login">
                        Logg inn
                    </a>
                </div>
            )}
        </div>
    );
};

const handleJsonNumbers = (value: unknown): { mobile?: string; phone?: string } | null => {
    if (typeof value === 'object') {
        return value;
    }
    return null;
};
